module.exports = __webpack_public_path__ + "media/images/exclamation_small-695b3d79e8c35c11994dc5bbb4f3a93f.png";